import { Center, Text, Box, Button } from '@chakra-ui/react';
import { HiOutlineHand } from 'react-icons/hi';
import { Link as ReactLink, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { logout } from '../redux/actions/userActions';

const LogoutScreen = () => {

    const location = useLocation();
    const redirectLocation = location.state?.from || '/services';

    const dispatch = useDispatch();
    const { userInfo, expireTime } = useSelector((state) => state.user);
    

    useEffect(() => {
        const today = new Date();
        const expireTimeDate = expireTime ? new Date(expireTime) : new Date();
        if(userInfo && ( today > expireTimeDate)) {
            dispatch(logout());
        }
    }, [dispatch, userInfo, expireTime]);
    

  return (
    <Center height='100vh' flexDirection='Column'>
      <Text fontSize={{ base: 'md', md: 'xl', lg: '4xl' }}>Your login session has expired.</Text>
      <Box m='2'>
        <HiOutlineHand size='50px' mt='2' />
      </Box>
      <Text>We logged out for you to protect your security.</Text>
      <Button as={ReactLink} to='/login' mt='2' state={{ from: redirectLocation}}>
        Log in again
      </Button>
    </Center>
  );
};

export default LogoutScreen;